<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..."
  type="ball-scale-multiple">
</ngx-spinner>
<div class="pad-lr-40 x" *ngIf="openRequested == true">
  <div class="">STATUS:
    <span class="status_review" [ngStyle]="{'color':pkgCodeStatus === 'rejected' ? 'red' : 'green' }">{{pkgCodeStatus |
      titlecase}}</span>
  </div>
</div>
<div class="pad-lr-40" *ngIf="openfusoRequested == true">
  <div class="">STATUS:
    <span class="status_review">{{fusoPkgCodeStatus | titlecase}}</span>
  </div>
</div>
<form [formGroup]="newPackageForm" #f="ngForm" novalidate>
  <section class="new_pack_info pad-top-40 no-mar-lr pad-btm-20 pad-lr-15">
    <div class="row">
      <div class="col-md-9 dta_title pad-btm-10" *ngIf="userRoleID == 1 || userRoleID == 3 && openRequested == true">
        {{'NEW_PKG_CODE'
        | translate}}</div>
      <div class="col-md-9 dta_title pad-btm-10" *ngIf="userRoleID != 1 && openfusoRequested == true">{{'New Fuso Package Code' | translate}}</div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group row" [ngClass]="{'has-error': newPackageForm.get('packageCode').invalid && f.submitted}">
          <label class="col-sm-6 col-form-label">{{'PKGCODE' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-sm-6">
            <input class="form-control" formControlName="packageCode" #input [value]="input.value.toUpperCase()"
              type="text" (blur)="checkPackageCode(PackageCode)" [(ngModel)]="packageId"
              placeholder="{{'packageExample' | translate}}">
            <errors [control]="newPackageForm.controls.packageCode"></errors>
            <div *ngIf="newPackageForm.get('packageCode').invalid && f.submitted" class="required-error">
              {{'PkgCodeRequired'
              | translate}}</div>
          </div>
        </div>
      </div>
      <div class="col-md-2" [hidden]="userRoleID == 1 && openRequested == true || openfusoRequested == true">
        <div class="lookup_text" (click)="showDialog()">{{'Package Reference' | translate}}</div>
      </div>
      <div class=" col-md-3 float-right" *ngIf="openRequested == true && userRoleID == 3">
        <div class="form-group row">
          <label class="col-sm-6 col-form-label">{{'SUPPLIERCODE' | translate}}</label>
          <div class="col-sm-6">
            <input class=" form-control" type="text" value="{{createdBySuppCode}}" disabled>
          </div>
        </div>
      </div>
    </div>
    <div class="row">

      <div class="col-md-3">
        <div class="form-group row"
          [ngClass]="{'has-error': newPackageForm.get('packagingName').invalid && f.submitted}">
          <label class="col-sm-6 col-form-label">{{'PKGNAME' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-sm-6">
            <input class="form-control" formControlName="packagingName" placeholder="" type="text">
            <errors [control]="newPackageForm.controls.packagingName"></errors>
            <div *ngIf="newPackageForm.get('packagingName').invalid && f.submitted" class="required-error">
              {{'FieldRequired'
              | translate}}</div>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <div class="form-group row"
          [ngClass]="{'has-error': newPackageForm.get('standardPackaging').invalid && f.submitted}">
          <label for="delPoints" class="col-sm-7 col-form-label">{{'STANDARDPACKAGING' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-sm-5">
            <select class="form-control" formControlName="standardPackaging">
              <option value="">{{'Select' | translate}}</option>
              <option *ngFor="let opt of standardPackageOpt" [value]="opt">{{opt}}</option>
            </select>
            <errors [control]="newPackageForm.controls.standardPackaging"></errors>
            <div *ngIf="newPackageForm.get('standardPackaging').invalid && f.submitted" class="required-error">
              {{'FieldRequired'
              | translate}}</div>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <div class="form-group row"
          [ngClass]="{'has-error': newPackageForm.get('specializedPackaging').invalid && f.submitted}">
          <label for="delPoints" class="col-sm-7 col-form-label">{{'SPECIALIZEDPKGING' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-sm-5">
            <select class="form-control" formControlName="specializedPackaging">
              <option value="">{{'Select' | translate}}</option>
              <option *ngFor="let opt of specialPackageOpt" [value]="opt">{{opt}}</option>
            </select>
            <errors [control]="newPackageForm.controls.specializedPackaging"></errors>
            <div *ngIf="newPackageForm.get('specializedPackaging').invalid && f.submitted" class="required-error">
              {{'FieldRequired'
              | translate}}</div>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-3">
        <div class="form-group row">
          <label class="col-sm-6 col-form-label">{{'TOTALBOXWEIGHT' | translate}}</label>
          <div class="col-sm-6">
            <input class="form-control" formControlName="totalMaxWeightBox" placeholder="" type="text" [ngModel]="totalBoxWeight()">
            <errors [control]="newPackageForm.controls.totalMaxWeightBox"></errors>
          </div>
        </div>
      </div> -->
    </div>
  </section>

  <section class="mar-top-30 new_pack_dimensions pad-btm-20">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-4">
          <div class="dta_sub_title pad-btm-30">{{'INNERPKG' | translate}}
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group row"
                [ngClass]="{'has-error': newPackageForm.get('innerPackDimW').invalid && f.submitted}">
                <label for="" class="col-sm-6 col-form-label">{{'W' | translate}}
                  <span class="required">*</span>
                </label>
                <div class="col-sm-6">
                  <input type="text" class="form-control" formControlName="innerPackDimW" placeholder=""
                    [pKeyFilter]="blockSpace" [(ngModel)]="innerPackW" (ngModelChange)="widthCompare()">
                  <errors [control]="newPackageForm.controls.innerPackDimW"></errors>
                  <div *ngIf="newPackageForm.get('innerPackDimW').invalid && f.submitted" class="required-error">
                    {{'FieldRequired'
                    | translate}}</div>
                  <div
                    *ngIf="newPackageForm.get('innerPackDimW').value == 0 && newPackageForm.get('innerPackDimW').value.length != 0"
                    class="required-error">{{'Inner Width cannot be of value 0' | translate}}</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row"
                [ngClass]="{'has-error': newPackageForm.get('innerPackDimL').invalid && f.submitted}">
                <label for="" class="col-sm-7 col-form-label">{{'L' | translate}}
                  <span class="required">*</span>
                </label>
                <div class="col-sm-5">
                  <input type="text" class="form-control" formControlName="innerPackDimL" placeholder=""
                    [(ngModel)]="innerPackL" (ngModelChange)="lengthCompare()" [pKeyFilter]="blockSpace">
                  <errors [control]="newPackageForm.controls.innerPackDimL"></errors>
                  <div *ngIf="newPackageForm.get('innerPackDimL').invalid && f.submitted" class="required-error">
                    {{'FieldRequired'
                    | translate}}</div>
                  <div
                    *ngIf="newPackageForm.get('innerPackDimL').value == 0 && newPackageForm.get('innerPackDimL').value.length != 0"
                    class="required-error">{{'Inner Length cannot be of value 0' | translate}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group row"
                [ngClass]="{'has-error': newPackageForm.get('innerPackDimH').invalid && f.submitted}">
                <label for="" class="col-sm-6 col-form-label">{{'H' | translate}}
                  <span class="required">*</span>
                </label>
                <div class="col-sm-6">
                  <input type="text" class="form-control" formControlName="innerPackDimH" placeholder=""
                    [(ngModel)]="innerPackH" (ngModelChange)="heightCompare()" [pKeyFilter]="blockSpace">
                  <errors [control]="newPackageForm.controls.innerPackDimH"></errors>
                  <div *ngIf="newPackageForm.get('innerPackDimH').invalid && f.submitted" class="required-error">
                    {{'FieldRequired'
                    | translate}}</div>
                  <div
                    *ngIf="newPackageForm.get('innerPackDimH').value == 0 && newPackageForm.get('innerPackDimH').value.length != 0"
                    class="required-error">{{'Inner Height cannot be of value 0' | translate}}</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row">
                <label for="" class="col-sm-7 col-form-label">{{'INNERVOL' | translate}}</label>
                <div class="col-sm-5">
                  <input type="text" class="form-control" formControlName="innerVolume" placeholder=""
                    [ngModel]="innerPackVol()" [(ngModel)]="InnVol">
                  <errors [control]="newPackageForm.controls.innerVolume"></errors>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 rgt_dash_brd pad-lft-20">
          <div class="dta_sub_title pad-btm-30">{{'EXTPKG' | translate}}</div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group row"
                [ngClass]="{'has-error': newPackageForm.get('externalPackDimW').invalid && f.submitted}">
                <label for="" class="col-sm-6 col-form-label">{{'W' | translate}}
                  <span class="required">*</span>
                </label>
                <div class="col-sm-6">
                  <input type="text" class="form-control" formControlName="externalPackDimW" placeholder=""
                    [(ngModel)]="externalPackW" (ngModelChange)="widthCompare()" [pKeyFilter]="blockSpace">
                  <errors [control]="newPackageForm.controls.externalPackDimW"></errors>
                  <div *ngIf="newPackageForm.get('externalPackDimW').invalid && f.submitted" class="required-error">
                    {{'FieldRequired'
                    | translate}}</div>
                  <div
                    *ngIf="newPackageForm.get('externalPackDimW').value == 0 && newPackageForm.get('externalPackDimW').value.length != 0"
                    class="required-error">{{'External Width cannot be of value 0' | translate}}</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row"
                [ngClass]="{'has-error': newPackageForm.get('externalPackDimL').invalid && f.submitted}">
                <label for="" class="col-sm-7 col-form-label">{{'L' | translate}}
                  <span class="required">*</span>
                </label>
                <div class="col-sm-5">
                  <input type="text" class="form-control" formControlName="externalPackDimL" placeholder=""
                    [(ngModel)]="externalPackL" (ngModelChange)="lengthCompare()" [pKeyFilter]="blockSpace">
                  <errors [control]="newPackageForm.controls.externalPackDimL"></errors>
                  <div *ngIf="newPackageForm.get('externalPackDimL').invalid && f.submitted" class="required-error">
                    {{'FieldRequired'
                    | translate}}</div>
                  <div
                    *ngIf="newPackageForm.get('externalPackDimL').value == 0 && newPackageForm.get('externalPackDimL').value.length != 0"
                    class="required-error">{{'External Length cannot be of value 0' | translate}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group row"
                [ngClass]="{'has-error': newPackageForm.get('externalPackDimH').invalid && f.submitted}">
                <label for="" class="col-sm-6 col-form-label">{{'H' | translate}}
                  <span class="required">*</span>
                </label>
                <div class="col-sm-6">
                  <input type="text" class="form-control" formControlName="externalPackDimH" placeholder=""
                    [(ngModel)]="externalPackH" (ngModelChange)="heightCompare()" [pKeyFilter]="blockSpace">
                  <errors [control]="newPackageForm.controls.externalPackDimH"></errors>
                  <div *ngIf="newPackageForm.get('externalPackDimH').invalid && f.submitted" class="required-error">
                    {{'FieldRequired'
                    | translate}}</div>
                  <div
                    *ngIf="newPackageForm.get('externalPackDimH').value == 0 && newPackageForm.get('externalPackDimH').value.length != 0"
                    class="required-error">{{'External Height cannot be of value 0' | translate}}</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row">
                <label for="" class="col-sm-7 col-form-label">{{'EXTVOL' | translate}}</label>
                <div class="col-sm-5">
                  <input type="text" class="form-control" formControlName="externalCubicMeter" placeholder=""
                    [ngModel]="externalVol()" [(ngModel)]="extVol" (ngModelChange)="folcheck()">
                  <errors [control]="newPackageForm.controls.externalCubicMeter"></errors>
                </div>
              </div>
            </div>
          </div>
          <div class="dimensionError" *ngIf="widthGreater == true">{{'External Width must be greater than internal width' | translate}}</div>
          <div class="dimensionError" *ngIf="lengthGreater == true">{{'External Length must be greater than internal Length' | translate}}</div>
          <div class="dimensionError" *ngIf="heightGreater == true">{{'External Height must be greater than internal  Height' | translate}}</div>
        </div>
        <div class="col-md-4 rgt_dash_brd pad-lft-20">
          <div class="dta_sub_title pad-btm-30">{{'FOLDABLE' | translate}}
            <span class="required">*</span>
            <label class="radio-inline pad-lft-30">
              <input type="radio" class="checkMark" name="isFoldable" formControlName="isFoldable" value='Yes'
                (click)="FoldableEnabled()">{{'Yes'
              | translate}}</label>
            <label class="radio-inline pad-lft-10">
              <input type="radio" class="checkMark" name="isFoldable" formControlName="isFoldable" value='No'
                (click)="foldableDisabled()" [checked]="'No'">{{'No' | translate}}</label>
            <label class="radio-inline pad-lft-10">
              <input type="radio" class="checkMark" name="isFoldable" formControlName="isFoldable" value='N/A'
                (click)="foldableNotApplicable()">{{'N/A'
              | translate}}</label>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group row"
                [ngClass]="{'has-error': newPackageForm.get('foldablePackDimW').invalid && f.submitted}">
                <label for="" class="col-sm-6 col-form-label">{{'W' | translate}}
                  <span class="required">*</span>
                </label>
                <div class="col-sm-6">
                  <input type="text" class="form-control" formControlName="foldablePackDimW" placeholder=""
                    [(ngModel)]="foldableW" [pKeyFilter]="blockSpace" (ngModelChange)="foldableVol()">
                  <errors [control]="newPackageForm.controls.foldablePackDimW"></errors>
                  <div *ngIf="newPackageForm.get('foldablePackDimW').invalid && f.submitted" class="required-error">
                    {{'FieldRequired'
                    | translate}}</div>
                  <div
                    *ngIf="newPackageForm.get('foldablePackDimW').value == 0 && newPackageForm.get('foldablePackDimW').value.length != 0"
                    class="required-error">{{'Foldable Width cannot be of value 0' | translate}}</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row"
                [ngClass]="{'has-error': newPackageForm.get('foldablePackDimL').invalid && f.submitted}">
                <label for="" class="col-sm-7 col-form-label">{{'L' | translate}}
                  <span class="required">*</span>
                </label>
                <div class="col-sm-5">
                  <input type="text" class="form-control" formControlName="foldablePackDimL" placeholder=""
                    [(ngModel)]="foldableL" [pKeyFilter]="blockSpace" (ngModelChange)="foldableVol()">
                  <errors [control]="newPackageForm.controls.foldablePackDimL"></errors>
                  <div *ngIf="newPackageForm.get('foldablePackDimL').invalid && f.submitted" class="required-error">
                    {{'FieldRequired'
                    | translate}}</div>
                  <div
                    *ngIf="newPackageForm.get('foldablePackDimL').value == 0 && newPackageForm.get('foldablePackDimL').value.length != 0"
                    class="required-error">{{'Foldable Length cannot be of value 0' | translate}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group row"
                [ngClass]="{'has-error': newPackageForm.get('foldablePackDimH').invalid && f.submitted}">
                <label for="" class="col-sm-6 col-form-label">{{'H' | translate}}
                  <span class="required">*</span>
                </label>
                <div class="col-sm-6">
                  <input type="text" class="form-control" formControlName="foldablePackDimH" placeholder=""
                    [(ngModel)]="foldableH" [pKeyFilter]="blockSpace" (ngModelChange)="foldableVol()">
                  <errors [control]="newPackageForm.controls.foldablePackDimH"></errors>
                  <div *ngIf="newPackageForm.get('foldablePackDimH').invalid && f.submitted" class="required-error">
                    {{'FieldRequired'
                    | translate}}</div>
                  <div
                    *ngIf="newPackageForm.get('foldablePackDimH').value == 0 && newPackageForm.get('foldablePackDimH').value.length != 0"
                    class="required-error">{{'Foldable Height cannot be of value 0' | translate}}</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row">
                <label for="" class="col-sm-7 col-form-label">{{'FOLDABLEVOL' | translate}}</label>
                <div class="col-sm-5">
                  <input type="text" class="form-control" formControlName="foldableVolume" placeholder=""
                    [ngModel]="foldableVol()" [(ngModel)]="folVol" (ngModelChange)="folcheck()">
                  <errors [control]="newPackageForm.controls.foldableVolume"></errors>
                  <!-- <div *ngIf="foldableGreater == true" class="dimensionError">Foldable Volume cannot be greater than External Volume</div> -->
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="foldableResult >= externalResult" class="dimensionError">{{'Foldable Volume must be smaller than External Volume' | translate}}</div>
        </div>
      </div>
    </div>
  </section>

  <section class="new_pack_misc pad-top-30 pad-btm-20">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-3">
          <div class="form-group row"
            [ngClass]="{'has-error': newPackageForm.get('permittedLoadCapacity').invalid && f.submitted}">
            <label for="delPoints" class="col-sm-8 col-form-label">{{'PERMITTEDLOADCAPACITY' | translate}}
              <span class="required">*</span>
            </label>
            <div class="col-sm-4">
              <input type="text" class="form-control" formControlName="permittedLoadCapacity" placeholder=""
                [(ngModel)]="loadCapacity" (ngModelChange)="totalBoxWeight()" [pKeyFilter]="blockSpace">
              <errors [control]="newPackageForm.controls.permittedLoadCapacity"></errors>
              <div *ngIf="newPackageForm.get('permittedLoadCapacity').invalid && f.submitted" class="required-error">
                {{'FieldRequired'
                | translate}}</div>
              <div
                *ngIf="newPackageForm.get('permittedLoadCapacity').value == 0 && newPackageForm.get('permittedLoadCapacity').value.length != 0"
                class="required-error">{{'Load Capacity cannot be of value 0' | translate}}</div>
              <!-- <div *ngIf="newPackageForm.get('permittedLoadCapacity').value < 0" class="required-error">{{'Permitted
                load capacity cannot have negative values' | translate}}</div> -->
              <div *ngIf="containerTypeBind== 'KLT' && newPackageForm.get('permittedLoadCapacity').value > 15"
                class="required-error">{{'Load Capacity cannot be of more than 15' | translate}}</div>

            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group row"
            [ngClass]="{'has-error': newPackageForm.get('packageTareWeight').invalid && f.submitted}">
            <label class="col-sm-8 col-form-label" for="packageTareWeight">{{'TAREWEIGHT' | translate}}
              <span class="required">*</span>
            </label>
            <div class="col-sm-4">
              <input class="form-control" formControlName="packageTareWeight" placeholder="" type="text"
                [(ngModel)]="tareWeight" [pKeyFilter]="blockSpace" (ngModelChange)="totalBoxWeight()">
              <errors [control]="newPackageForm.controls.packageTareWeight"></errors>
              <div *ngIf="newPackageForm.get('packageTareWeight').invalid && f.submitted" class="required-error">
                {{'FieldRequired'
                | translate}}</div>
              <div
                *ngIf="newPackageForm.get('packageTareWeight').value == 0 && newPackageForm.get('packageTareWeight').value.length != 0"
                class="required-error">{{'Tare Weight cannot be of value 0' | translate}}</div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group row"
            [ngClass]="{'has-error': newPackageForm.get('totalPackageWeight').invalid && f.submitted}">
            <label class="col-sm-8 col-form-label" for="packageTareWeight">{{'Total Weight[Kg]' | translate}}
              <!-- <span class="required">*</span> -->
            </label>
            <div class="col-sm-4">
              <input class="form-control" formControlName="totalMaxWeightBox" placeholder="" type="text"
                [ngModel]="totalBoxWeight()">
              <!-- <errors [control]="newPackageForm.controls.packageTareWeight"></errors> -->
              <!-- <div *ngIf="newPackageForm.get('packageTareWeight').invalid && f.submitted" class="required-error">{{'FieldRequired'
                | translate}}</div>
              <div *ngIf="newPackageForm.get('packageTareWeight').value == 0 && newPackageForm.get('packageTareWeight').value.length != 0"
                class="required-error">{{'Tare Weight cannot be of value 0' | translate}}</div>-->
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group row"
            [ngClass]="{'has-error': newPackageForm.get('containerType').invalid && f.submitted}">
            <label for="delPoints" class="col-sm-6 col-form-label">{{'CONTAINERTYPE' | translate}}
              <!-- <span class="required">*</span> -->
            </label>
            <div class="col-sm-6">
              <select #mySelect [(ngModel)]="containerTypeBind" class="form-control" formControlName="containerType"
                (change)="onContainerSelect(mySelect.value)">
                <option value="">Select</option>
                <option *ngFor="let opt of containerTypeOpt" [value]="opt">{{opt}}</option>
              </select>
              <errors [control]="newPackageForm.controls.containerType"></errors>
              <!-- <div *ngIf="newPackageForm.get('containerType').invalid && f.submitted" class="required-error"> This field is Required</div> -->
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group row"
            [ngClass]="{'has-error': newPackageForm.get('packageMaterial').invalid && f.submitted}">
            <label for="delPoints" class="col-sm-6 col-form-label">{{'PKGMATERIAL' | translate}}
              <span class="required">*</span>
            </label>
            <div class="col-sm-6">
              <input list="packageMaterialData" type="text" name="packMaterial" class="form-control"
                formControlName="packageMaterial" placeholder="Type or Select" />
              <datalist id="packageMaterialData">
                <!--[if IE 9]><select disabled style="display:none"><![endif]-->
                <!-- <option *ngFor="let opt of packageMaterialOpt" [value]=opt> -->
                <option value="Plastic"></option>
                <option value="Steel"></option>
                <option value="Iron"></option>
                <option value="Carton Box"></option>
                <!--[if IE 9]></select><![endif]-->
              </datalist>
              <errors [control]="newPackageForm.controls.packageMaterial"></errors>
              <div *ngIf="newPackageForm.get('packageMaterial').invalid && f.submitted" class="required-error">
                {{'FieldRequired'
                | translate}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>
  <div *ngIf="openRequested == true && rejectionComment == null" class="mar-top-10">
    <strong>{{'COMMENTS' | translate}}:</strong>
    <p>{{pkgCodeComment}}</p>
  </div>
  <div *ngIf="openRequested == true && rejectionComment != null" class="mar-top-10">
    <strong>{{'COMMENTS' | translate}}:</strong>
    <p class="required">{{rejectionComment}}</p>
  </div>
  <div *ngIf="openfusoRequested == true" class="mar-top-10">
    <strong>{{'COMMENTS' | translate}}:</strong>
    <p>{{fusoPkgComment}}</p>
  </div>

  <section [hidden]="openRequested == true || openfusoRequested == true || adminEdit == true || admitFusoEdit == true"
    class="new_package mar-top-20 pad-lr-20">
    <div class="container-fluid">
      <div class="row pad-tb-30 action_section">
        <div class="col-md-4 text-center">
          <button type="submit" class="btn btn-dark" (click)="openCommentModal(addComment)"
            id="createPkgSubmit">{{'SUBMIT'
            | translate}}</button>
        </div>
        <div class="col-md-4 text-left">
          <button type="button" class="btn btn-dark-brd" (click)="onCancel()" id="createPkgCancel">{{'CANCEL' |
            translate}}</button>
        </div>
      </div>
    </div>
  </section>
  <section *ngIf="openRequested == true && userRoleID == 3 " class="new_package mar-top-20 pad-lr-20">
    <div class="container-fluid">
      <div class="row pad-tb-30 action_section">
        <div class="col-md-4 text-center">
          <button type="submit" class="btn btn-dark" (click)="showStatusDialog()" id="logAppSubmit">{{'Submit' |
            translate}}</button>
        </div>
        <div class="col-md-4 text-left">
          <button type="button" class="btn btn-dark-brd" (click)="onCancel()"
            [hidden]="openRequested == true && userRoleID == 3" id="logAppCancel">{{'CANCEL' | translate}}</button>
        </div>
      </div>
    </div>
  </section>
  <section *ngIf="adminEdit == true || admitFusoEdit == true" class="new_package mar-top-20 pad-lr-20">
    <div class="container-fluid">
      <div class="row pad-tb-30 action_section">
        <div class="col-md-4 text-center">
          <button type="submit" class="btn btn-dark" (click)="openAdminCommentModal()" id="logAdminSubmit">{{'SAVE' |
            translate}}</button>
        </div>
      </div>
    </div>
  </section>
</form>

<ng-template #PackageCode>
  <div class="modal-body">
    <p>{{'ChkPkgAvailiblity' | translate}}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="checkAvailiblity()" id="chkPkgAvail">{{'Check' |
      translate}}</button>
  </div>
</ng-template>

<ng-template #addComment let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">{{'PopupCommentLabel' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row mar-top-10">
      <h5 class="col-md-12">{{'PostYourCommentsBelow' | translate}}</h5>
      <div class="col-md-12">
        <textarea class="form-control" [(ngModel)]="pkgComment" (ngModelChange)="onCommentEnter($event)"
          maxlength="100"></textarea>
      </div>
      <div *ngIf="pkgCommentError == true" class="error">
        <p>
          {{'Please enter your comment for New Package request.' | translate}}
        </p>
      </div>
      <p class="error" [hidden]="pkgComment?.length < 100">{{'You have exceeded maximum character limit' | translate}}
      </p>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-dark" (click)="submitNewPackageForm()" [hidden]="createdBySM == true"
      id="submitNewPkgFrm">{{'Create'
      | translate}}</button>
    <button type="button" class="btn btn-dark" (click)="submitSMNewPackage()" [hidden]="createdBySM != true"
      id="submitNewPkgFrm">{{'Create'
      | translate}}</button>
    <button type="button" class="btn btn-dark-brd" (click)="c('Close click')" id="cancelNewPkgFrm">{{'CANCEL' |
      translate}}</button>
  </div>
</ng-template>

<p-dialog header="{{'SURE_MAKE_CHANGES'| translate }}" [(visible)]="addAdminComment" [responsive]="true"
  showEffect="fade" [modal]="true" [closable]="true"  [style]="{width: '600'}">
  <div class="row mar-top-10">
    <h5 class="col-md-12">{{'Please add your comment for changes in Package Code' | translate}}</h5>
    <div class="col-md-12">
      <textarea class="form-control" [(ngModel)]="pkgComment" (ngModelChange)="onCommentEnter()"
        maxlength="100"></textarea>
    </div>
    <div *ngIf="pkgCommentError == true" class="error">
      <p>
        {{'Please add your comment for changes in Package Code' | translate}}
      </p>
    </div>
    <p class="error" [hidden]="pkgComment?.length < 100">{{'You have exceeded maximum character limit' | translate}}</p>
  </div>
  <p-footer>
    <button type="button" class="btn btn-dark" (click)="submitNewPackageForm()" [hidden]="createdBySM == true"
      id="submitNewPkgFrm">{{'Save Changes' | translate}}</button>
    <button type="button" class="btn btn-dark-brd" (click)="addAdminComment = false" id="cancelNewPkgFrm">{{'CANCEL' |
      translate}}</button>
  </p-footer>
</p-dialog>

<p-dialog header="Please make a selection and write appropriate comment related to this decision if any"
  [(visible)]="statusDisplay" [responsive]="true" showEffect="fade" [modal]="true" [closable]="true"  [style]="{width: '600'}">
  <p>
    {{'SELECT_STATUS' | translate}}
  </p>
  <div class="row mar-btm-20">
    <div class="col-md-12">
      <select class="form-control" [(ngModel)]="status" (ngModelChange)="onStatusChange($event)">
        <option value="0">Select</option>
        <option value="1">{{'APPROVE' | translate}}</option>
        <option value="2">{{'REJECT' | translate}}</option>
      </select>
    </div>
  </div>
  <div class="row mar-top-20" *ngIf="showStatusComment">
    <div class="col-md-12">
      <textarea class="form-control" [(ngModel)]="pkgComment" (ngModelChange)="onCommentEnter($event)"
        maxlength="100"></textarea>
    </div>
    <p class="error" [hidden]="pkgComment?.length < 100">{{'You have exceeded maximum character limit' | translate}}</p>
    <div [hidden]="!pkgCommentError" class="error">
      <p>
        {{'Please enter your comment for rejection.' | translate}}
      </p>
    </div>
    <!-- <p class="error" [hidden]="pkgComment?.length < 100">You have exceeded maximum character limit</p> -->
  </div>
  <div class="row mar-top-20" *ngIf="!showStatusComment">
    <div class="col-md-12">
      <textarea class="form-control" [(ngModel)]="pkgComment" (ngModelChange)="onCommentEnter($event)"
        maxlength="100"></textarea>
    </div>
    <p class="error" [hidden]="pkgComment?.length < 100">{{'You have exceeded maximum character limit' | translate}}</p>
  </div>

  <p-footer>
    <button type="button" class="btn btn-dark" (click)="updatePkgStatus()" id="updatePkgStatusBtn">{{'Change Status' |
      translate}}</button>
    <button type="button" class="btn btn-dark-brd" (click)="statusDisplay=false" id="cancelPkgStatusBtn">{{'CANCEL' |
      translate}}</button>
  </p-footer>
</p-dialog>

<p-dialog id="refModal" header="{{'Lookup Reference for Package Code' | translate}}" [(visible)]="display"
  [responsive]="true" showEffect="fade" [modal]="true" [closable]="true" [style]="{width: '800'}">
  <div class="codeList mar-top-20">
    <p-table [value]="packageLookup" [responsive]="true" [rows]="10" [paginator]="true" [pageLinks]="3"
    [rowsPerPageOptions]="[10,25,50,100]">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="packageCode" style="width:20%" *ngIf="userRoleID == 1 || (userRoleID == 3 && openRequested == true)"
        >{{'PKGCODE' | translate}}<p-sortIcon field="packageCode"></p-sortIcon></th>
        <th pSortableColumn="fusoPackageCode" style="width:20%" *ngIf="userRoleID != 1" [hidden]="userRoleID == 3 && openRequested == true"
        >{{'PKGCODE' | translate}}<p-sortIcon field="fusoPackageCode"></p-sortIcon></th>
        <th pSortableColumn="externalPackDimL" style="width:20%">{{'LENGTH' | translate}}<p-sortIcon field="externalPackDimL"></p-sortIcon></th>
        <th pSortableColumn="externalPackDimW" style="width:20%">{{'WIDTH' | translate}}<p-sortIcon field="externalPackDimW"></p-sortIcon></th>
        <th pSortableColumn="externalPackDimH" style="width:20%">{{'HEIGHT' | translate}}<p-sortIcon field="externalPackDimH"></p-sortIcon></th>
        <th pSortableColumn="totalMaxWeightBox" style="width:20%">{{'WEIGHT' | translate}}<p-sortIcon field="totalMaxWeightBox"></p-sortIcon></th>
      </tr>
      <tr>
        <th>
          
        </th>
        <th *ngIf="userRoleID == 1 || (userRoleID == 3 && openRequested == true)">
          <p-columnFilter  type="text" field="packageCode"></p-columnFilter>
        </th>
        <th *ngIf="userRoleID != 1" [hidden]="userRoleID == 3 && openRequested == true">
          <p-columnFilter  type="text" field="fusoPackageCode"></p-columnFilter>
        </th>
        <th>
          <p-columnFilter type="text" field="externalPackDimL"></p-columnFilter>
        </th>
        <th>
          <p-columnFilter type="text" field="externalPackDimW"></p-columnFilter>
        </th>
        <th>
          <p-columnFilter type="text" field="externalPackDimH"></p-columnFilter>
        </th>
        <th>
          <p-columnFilter type="text" field="totalMaxWeightBox"></p-columnFilter>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-value>
      <tr>
          <td *ngIf="userRoleID == 1 || (userRoleID == 3 && openRequested == true)">{{value.packageCode}}</td>
          <td *ngIf="userRoleID != 1" [hidden]="userRoleID == 3 && openRequested == true">{{value.fusoPackageCode}}</td>
          <td>{{value.externalPackDimL}}</td>
          <td>{{value.externalPackDimW}}</td>
          <td>{{value.externalPackDimH}}</td>
          <td>{{value.totalMaxWeightBox}}</td>
      </tr>
    </ng-template>
    </p-table>
    <!-- <p-dataTable [value]="packageLookup" [responsive]="true" [rows]="10" [paginator]="true" [pageLinks]="3"
      [rowsPerPageOptions]="[10,25,50,100]">
      <p-column *ngIf="userRoleID == 1 || (userRoleID == 3 && openRequested == true)" field="packageCode"
        header="{{'PKGCODE' | translate}}" [sortable]="true" [filter]="true"
        filterPlaceholder="{{'SEARCH_PKG_CODE' | translate}}"></p-column>
      <p-column *ngIf="userRoleID != 1" [hidden]="userRoleID == 3 && openRequested == true" field="fusoPackageCode"
        header="{{'PKGCODE' | translate}}" [sortable]="true" [filter]="true"
        filterPlaceholder="{{'SEARCH_PKG_CODE' | translate}}"></p-column>
      <p-column field="externalPackDimL" header="{{'LENGTH' | translate}}" [sortable]="true" [filter]="true"
        filterPlaceholder="{{'SEARCH_LENGTH' | translate}}"></p-column>
      <p-column field="externalPackDimW" header="{{'WIDTH' | translate}}" [sortable]="true" [filter]="true"
        filterPlaceholder="{{'SEARCH_WIDTH' | translate}}"></p-column>
      <p-column field="externalPackDimH" header="{{'HEIGHT' | translate}}" [sortable]="true" [filter]="true"
        filterPlaceholder="{{'SEARCH_HEIGHT' | translate}}"></p-column>
      <p-column field="totalMaxWeightBox" header="{{'WEIGHT' | translate}}" [sortable]="true" [filter]="true"
        filterPlaceholder="{{'Search Weight' | translate}}"></p-column>
    </p-dataTable> -->
  </div>

  <p-footer>
    <button type="button" pButton class="btn-dark-brd" (click)="closeLookup()"
      label="{{'Close' | translate}}"></button>
  </p-footer>
</p-dialog>